export default {
  title: 'Portail Clinique',
  dashboard: {
    title: 'Tableau de bord Clinique',
    subtitle: 'Vue d\'ensemble des activités, triages et file d\'attente en temps réel.',
    noClinicSelectedTitle: 'Aucune clinique active sélectionnée',
    noClinicSelectedSubtitle: 'Veuillez sélectionner un établissement clinique pour accéder au tableau de bord.',
    kpis: {
      totalPatientsInQueue: 'Patients en File',
      activeTriageCount: 'Triages en Cours',
      urgentCasesCount: 'Cas Urgents',
      onlinePractitionersCount: 'Praticiens Actifs',
    },
    liveQueueTitle: 'File d\'attente en Direct',
    emptyQueue: 'Aucun patient actuellement dans la file d\'attente.',
    headers: {
      patient: 'Patient / Ticket',
      priority: 'Priorité',
      status: 'Statut',
      time: 'Date / Heure',
    },
  },
  queue: {
    title: 'File d\'attente & Triage',
    subtitle: 'Gestion en temps réel de l\'accueil, du triage et des appels en consultation.',
    allColumns: 'Toutes les colonnes',
    tvScreen: 'Écran TV',
    tvScreenTooltip: 'Ouvrir l\'écran TV d\'appel en salle d\'attente (nouvel onglet / plein écran)',
    checkInButton: 'Admissions / Ticket',
    searchPlaceholder: 'Rechercher patient, #ticket, MRN...',
    filterAll: 'Tous les départements',
    filterUrgent: 'Urgences',
    filterWaiting: 'En attente',
    noPatients: 'Aucun patient',
    noMatch: 'Aucun patient actuellement en file d\'attente ne correspond à',
    searchAllOrAdmit: 'Rechercher dans tous les dossiers / Admettre',
    returnedToWaiting: 'Renvoyé en attente',
    callModal: {
      title: 'Appeler le Patient en Salle',
      targetRoomLabel: 'Salle de Consultation Target',
      selectRoom: 'Sélectionner une salle (Optionnel)',
      cancel: 'Annuler',
      confirm: 'Appeler le Patient',
      calling: 'Appel en cours...',
    },
    returnModal: {
      title: 'Renvoyer le Patient en Attente',
      confirm: 'Confirmer le Renvoi',
      cancel: 'Annuler',
    },
    actions: {
      triage: 'Triage / Constantes',
      retriage: 'Re-triage',
      call: 'Appeler',
      return: 'Renvoyer',
      finish: 'Terminer',
      details: 'Fiche',
      edit: 'Modifier',
      delete: 'Supprimer',
    },
    status: {
      REGISTERED: 'Enregistrés',
      WAITING: 'En Attente Triage',
      TRIAGED: 'Triagés / Prêts',
      IN_CONSULTATION: 'En Consultation',
      COMPLETED: 'Terminés',
      CANCELLED: 'Annulés / Expirés',
    },
    priority: {
      LOW: 'Faible',
      NORMAL: 'Normale',
      HIGH: 'Élevée',
      URGENT: 'Urgente',
      EMERGENCY: 'Urgence Vitale',
    },
  },
  vitalsModal: {
    title: 'Saisie des Constantes Vitales & Triage',
    subtitle: 'Prise de constantes et évaluation du niveau de priorité clinique.',
    systolicBP: 'Pression Systolique (mmHg)',
    diastolicBP: 'Pression Diastolique (mmHg)',
    pulse: 'Fréquence Cardiaque (bpm)',
    temperature: 'Température (°C)',
    weight: 'Poids (kg)',
    height: 'Taille (cm)',
    spo2: 'Saturation SpO2 (%)',
    prioritySelect: 'Niveau de Priorité Clinique',
    triageNotes: 'Observations & Notes de Triage',
    triageNotesPlaceholder: 'Ex: Symptômes observés, niveau de douleur, allergies signalées...',
    submit: 'Enregistrer le Triage',
    saving: 'Enregistrement...',
  },
  checkInModal: {
    title: 'Admissions & Enregistrement Patient',
    subtitle: 'Attribuer un ticket d\'attente et inscrire le patient dans la file.',
    existingPatient: 'Patient Existant (MRN)',
    newPatient: 'Nouveau Patient',
    selectPatient: 'Sélectionner le Patient',
    searchPatientPlaceholder: 'Rechercher par Nom, Prénom, N° MRN, Téléphone...',
    recentRecords: 'Dossiers récents',
    matchingRecords: 'dossier(s) correspondant(s)',
    choose: 'Choisir',
    change: 'Changer',
    noExistingMatch: 'Aucun dossier patient existant trouvé pour',
    createThisPatient: 'Créer la fiche de ce patient',
    admissionSettings: 'Paramètres d\'Admission',
    reason: 'Motif de la venue / Symptômes principaux',
    reasonPlaceholder: 'Ex: Fièvre élevée, céphalées sévères depuis 2 jours...',
    priority: 'Priorité Initiale',
    submit: 'Émettre le Ticket & Inscrire en Queue',
    submitting: 'Admission en cours...',
  },
  billing: {
    title: 'Facturation & Caisse Clinique',
    subtitle: 'Gestion des encaissements, factures et règlements d\'actes.',
    createInvoiceButton: 'Nouvelle Facture',
    emptyInvoices: 'Aucune facture enregistrée pour cet établissement.',
    loading: 'Chargement de la caisse...',
    filters: {
      all: 'Toutes les factures',
      issued: 'Émises / En attente',
      partiallyPaid: 'Partiellement payées',
      paid: 'Payées / Clôturées',
    },
    headers: {
      invoiceNumber: 'N° Facture',
      patient: 'Patient',
      insuranceCoverage: 'Couverture / Assurance',
      grossTotal: 'Total Brut',
      patientShare: 'Part Patient',
      collected: 'Encaissé',
      remaining: 'Reste à payer',
      amount: 'Montant Total',
      status: 'Statut',
      date: 'Date',
      actions: 'Actions',
    },
    paymentModal: {
      title: 'Encaisser le Règlement',
      paymentMethod: 'Mode de Paiement',
      methods: {
        CASH: 'Espèces',
        CARD: 'Carte Bancaire',
        MOBILE_MONEY: 'Mobile Money',
        INSURANCE: 'Tiers-Payant / Assurance',
      },
      amountPaid: 'Montant Encaissé',
      submit: 'Confirmer l\'encaissement',
    },
    status: {
      PENDING: 'En attente',
      ISSUED: 'Émise',
      PARTIALLY_PAID: 'Partiellement payée',
      PAID: 'Payée',
      CANCELLED: 'Annulée',
    },
  },
  login: {
    title: 'Portail Établissement & Clinique',
    subtitle: 'Connexion sécurisée au système de gestion d\'établissement Ekose-Rx.',
    emailLabel: 'Adresse E-mail Professionnelle',
    passwordLabel: 'Mot de Passe',
    submitButton: 'Se connecter à l\'établissement',
    submitting: 'Authentification en cours...',
  },
};
